import { ImageAsset } from "@/components/ImageAsset";
import { responsiveImage } from "@/lib/helper";
import theme from "@/styles/theme";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

export const NetworkPersonCard = ({name, role, photo, localImage, ...props}) => {
  return (
    <Grid container spacing={1} justifyContent="center">
      <Grid
        item
        xs={8}
        md={12}
        sx={{
          display: "flex",
          justifyContent: "center",
          "& img": {
            borderRadius: "9999px",
            filter: "grayscale(100%)",
          },
        }}
      >
        <ImageAsset
          url={responsiveImage(photo?.formats, 960)}
          width={320}
          height={320}
        />
        {localImage && (
          <ImageAsset url={localImage} local={true} width={320} height={320} />
        )}
      </Grid>
      <Grid item xs={12}>
        <Typography
          variant="h5"
          textAlign="center"
          sx={{ color: theme.palette.common.black, mt: 2, mb: -1 }}
        >
          {name}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1" textAlign="center">
          {role}
        </Typography>
      </Grid>
    </Grid>
  );
};